import { api } from '@/helpers/apiClient'
import { billingPriceScheduleDtoSchema, type BillingPriceScheduleDto } from '@lib/dto/billing.dto'
import type { SchedulePriceInput } from '@lib/input/billing.input'
import type { IOpsPricingService } from '@/types/OpsPricingService.types'

const BASE = '/ops/billing/prices'

/** The price per live envelope over time: the schedule staff read, and ADMIN adds to. */
class OpsPricingService implements IOpsPricingService {
  schedule(): Promise<BillingPriceScheduleDto> {
    return api.get(BASE, billingPriceScheduleDtoSchema)
  }

  schedulePrice(input: SchedulePriceInput): Promise<BillingPriceScheduleDto> {
    return api.post(BASE, input, billingPriceScheduleDtoSchema)
  }
}

export const opsPricingService = new OpsPricingService()
